import { useValue } from "@tldraw/state-react";
function useLicenseManagerState(licenseManager) {
  return useValue("watermarkState", () => licenseManager.state.get(), [licenseManager]);
}
function useLicenseFeatureFlag(licenseManager, feature) {
  return useValue("licenseFeature", () => licenseManager.isFeatureEnabled(feature), [
    licenseManager,
    feature
  ]);
}
export {
  useLicenseFeatureFlag,
  useLicenseManagerState
};
//# sourceMappingURL=useLicenseManagerState.mjs.map
